/* Eine getippte Reifengrösse gehört nicht in die Volltextsuche.

   Shopify zerlegt „295 35 18" in drei Zahlen und liefert alles, was irgendeine
   davon enthält: Bei fünf Treffern passte genau einer. Für einen Reifenshop ist
   das die häufigste Eingabe überhaupt und damit der wichtigste Fall.

   Deshalb wird die Eingabe abgefangen, bevor sie an /search geht, und auf die
   indexierbare Grössen-Tag-Seite der passenden Kollektion umgeleitet. Die
   Produktliste kommt damit direkt aus der Kollektion und hängt nicht vom
   zeitweise unvollständigen Shopify-Suchindex ab.

   Erkannt werden die üblichen Schreibweisen:

       295 35 18        295/35 R18        295/35R18
       295-35-18        295/35/18         295/35 R18 103Y
       2953518          295/35 ZR18       295/35 RF18

   Bewusst streng: Nur wenn alle drei Zahlen in gültigen Bereichen liegen, wird
   umgeleitet. „225 Michelin" oder „18 Zoll" bleiben Volltextsuche — eine
   Umleitung, die daneben liegt, ist schlimmer als eine mittelmässige
   Trefferliste, weil der Kunde nicht sieht, was passiert ist.

   Der Lastindex am Ende wird gelesen, aber nicht gefiltert: Er steht in einem
   eigenen Metafeld, und wer „103Y" mittippt, meint die Grösse, nicht eine
   zusätzliche Einschränkung. */
(function () {
  'use strict';

  /* Nur einmal.

     Auf der Suchergebnisseite bindet sowohl die Kopfleiste als auch die
     Suchsection dieses Skript ein — zwei <script>-Tags mit derselben Adresse
     werden einmal geladen, aber zweimal ausgeführt. Ohne diese Sperre standen
     alle Zuhörer doppelt, und das Grössenangebot im Nulltreffer erschien
     wörtlich zweimal hintereinander. */
  if (window.vantiqGroesse) return;

  /* Reale Grenzen, keine Fantasiewerte: Unter 125 und über 395 gibt es keine
     Personenwagenreifen, Querschnitte laufen von 20 bis 95, Felgen von 12 bis
     24 Zoll. Ausserhalb davon ist es keine Grösse, sondern eine Zahlenfolge. */
  var GRENZEN = {
    breite: [125, 395],
    quer: [20, 95],
    zoll: [12, 24]
  };

  function imBereich(wert, feld) {
    return wert >= GRENZEN[feld][0] && wert <= GRENZEN[feld][1];
  }

  /* Gibt {breite, quer, zoll} zurück oder null. */
  function groesseLesen(text) {
    if (!text) return null;

    /* Trennzeichen vereinheitlichen: Schrägstrich, Bindestrich, Leerzeichen
       und das R vor dem Zoll führen alle auf dasselbe. Das R darf nur zwischen
       Zahlen stehen — sonst würde aus „Bridgestone R18" eine Grösse. */
    var roh = String(text)
      .toLowerCase()
      .replace(/(\d)\s*(?:zrf|zr|rf|r)\s*(\d)/g, '$1 $2')
      .replace(/[\/\-.,]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    /* Sieben Ziffern am Stück sind eine Grösse ohne Trennzeichen: „2953518".

       Eine sehr verbreitete Eingabe — auf der Tastatur ist sie die schnellste,
       und in der Volltextsuche ist sie garantiert ein Nulltreffer, weil kein
       Produkttitel diese Ziffernfolge enthält.

       Die Zerlegung 3+2+2 ist eindeutig: Personenwagen-Breiten sind immer
       dreistellig (125–395), Querschnitt und Zoll immer zweistellig. Andere
       Aufteilungen ergäben Werte ausserhalb der Grenzen und werden unten
       ohnehin abgewiesen. Bei sechs oder acht Ziffern wäre es mehrdeutig —
       die bleiben Volltextsuche. */
    if (/^\d{7}$/.test(roh)) {
      roh = roh.slice(0, 3) + ' ' + roh.slice(3, 5) + ' ' + roh.slice(5);
    }

    var teile = roh.split(' ');
    if (teile.length < 3) return null;

    var breite = parseInt(teile[0], 10);
    var quer = parseInt(teile[1], 10);
    var zoll = parseInt(teile[2], 10);

    if (isNaN(breite) || isNaN(quer) || isNaN(zoll)) return null;

    /* Die Zahlen müssen für sich stehen — „2955" ist keine Breite von 295. */
    if (teile[0] !== String(breite) || teile[1] !== String(quer) || teile[2] !== String(zoll)) {
      return null;
    }

    if (!imBereich(breite, 'breite') || !imBereich(quer, 'quer') || !imBereich(zoll, 'zoll')) {
      return null;
    }

    /* Alles ab dem vierten Teil darf nur der Last- und Geschwindigkeitsindex
       sein („103y", „91 v"). Steht dort ein Wort, war es keine reine
       Grösseneingabe und die Volltextsuche ist die bessere Antwort. */
    for (var i = 3; i < teile.length; i++) {
      if (!/^\d{2,3}[a-z]{0,2}$/.test(teile[i]) && !/^[a-z]{1,2}$/.test(teile[i])) {
        return null;
      }
    }

    return { breite: breite, quer: quer, zoll: zoll };
  }

  function lokalerPfad(pfad) {
    var roh = String(pfad || '/collections/reifen');
    var wurzel = String(window.Shopify?.routes?.root || window.routes?.root_url || '/')
      .replace(/\/+$/, '');
    if (!wurzel || wurzel === '/' || roh === wurzel || roh.indexOf(wurzel + '/') === 0) {
      return roh;
    }
    return (wurzel + '/' + roh.replace(/^\//, '')).replace(/\/{2,}/g, '/');
  }

  /* Produktquelle ist die Grössen-Tag-Seite einer Kollektion.

     Genau diese Seiten bilden den veröffentlichten Katalog vollständig ab:
     `/collections/winterreifen/225-40-18` enthält 78 Produkte, während der
     Facettenweg über `/search?q=*` am 17.09.2026 zeitgleich nur 35 lieferte.
     Die nachgeladene Filterspalte darf weiterhin die Suche verwenden; sie ist
     aber nicht mehr die Quelle der sichtbaren Produktliste. */
  function zielAdresse(g, tag) {
    var sammlungen = {
      Sommerreifen: window.routes?.summer_tire_collection_url || '/collections/sommerreifen',
      Winterreifen: window.routes?.winter_tire_collection_url || '/collections/winterreifen',
      Ganzjahresreifen: window.routes?.all_season_tire_collection_url || '/collections/ganzjahresreifen',
    };
    var basis = sammlungen[tag] || window.routes?.tire_collection_url || '/collections/reifen';
    var groessenTag = g.breite + '-' + g.quer + '-' + g.zoll;
    return lokalerPfad(String(basis).replace(/\/$/, '') + '/' + groessenTag);
  }

  /* Nach aussen sichtbar, damit die Suchergebnisseite denselben Leser nutzen
     kann statt einer zweiten, leicht abweichenden Fassung. */
  window.vantiqGroesse = { lesen: groesseLesen, adresse: zielAdresse };

  /* --- Abfangen, bevor das Formular an /search geht -------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('role') !== 'search') return;

    var feld = form.querySelector('input[name="q"]');
    if (!feld) return;

    var g = groesseLesen(feld.value);
    if (!g) return;

    e.preventDefault();
    window.location.href = zielAdresse(g, form.dataset.groessentag);
  });

  /* --- Nulltreffer, der eigentlich eine Grösse war -----------------------

     Das Abfangen oben greift nur bei Suchen, die über das Formular laufen.
     Wer über einen gemerkten Link, aus einer Mail oder von einer Suchmaschine
     auf /search?q=2953518 kommt, sieht sonst „keine Treffer" — obwohl es die
     Grösse gibt.

     Bewusst ein Angebot und keine stille Umleitung: Der Kunde hat eine Seite
     angesteuert und soll sehen, was mit seiner Eingabe passiert. */
  document.addEventListener('DOMContentLoaded', function () {
    var platz = document.querySelector('[data-rolle="groesse-angebot"]');
    if (!platz) return;

    var q = new URLSearchParams(window.location.search).get('q');
    var g = groesseLesen(q);
    if (!g) return;

    var name = g.breite + '/' + g.quer + ' R' + g.zoll;
    var link = document.createElement('a');
    link.href = zielAdresse(g, platz.dataset.groessentag);
    link.textContent = window.vantiqText('size_search.show_all', { size: name });

    platz.appendChild(document.createTextNode(window.vantiqText('size_search.offer', { size: name })));
    platz.appendChild(link);
    platz.hidden = false;
  });
})();
